import Axios from 'axios'
import { getErrorMessage, SEARCH_URL } from '@/main'

const state = {
  searchStructure: null,
  // searchOptions: _.cloneDeep(defaultSearchOptions),
  searchResult: null,
  // searchResultOptions: _.cloneDeep(defaultSearchResultOptions),
  searchBuildDate: null,
}

const getters = {
  SEARCH_STRUCTURE: (state) => state.searchStructure,
  SEARCH_OPTIONS: (state) => state.searchOptions,
  // DEFAULT_SEARCH_OPTIONS: () => defaultSearchOptions,
  SEARCH_RESULT: (state) => state.searchResult,
  // SEARCH_RESULT_OPTIONS: (state) => state.searchResultOptions,
}

const mutations = {
  SET_SEARCH_STRUCTURE: (state, payload) => {
    state.searchStructure = payload
  },
  // SET_SEARCH_OPTIONS: (state, payload) => {
  //   state.searchOptions = payload
  // },
  // RESET_SEARCH_OPTIONS: (state) => {
  //   state.searchOptions = defaultSearchOptions
  // },
  SET_SEARCH_RESULT: (state, payload) => {
    state.searchResult = payload
  },
  RESET_SEARCH_RESULT: (state) => {
    state.searchResult = null
  },
  // SET_SEARCH_RESULT_OPTIONS: (state, payload) => {
  //   state.searchResultOptions = payload
  // },
  // RESET_SEARCH_RESULT_OPTIONS: (state) => {
  //   state.searchResultOptions = defaultSearchResultOptions
  // },
}

const actions = {}

export function prepareSearchMetadata(context) {
  Axios.get(`${SEARCH_URL}/metadata`)
    .then((response) => {
      context.commit('setFeatures', { search: { category: 'module' } })
      context.commit('SET_HAZARD_SOURCES', response.data.hazardStats.sources)
      context.commit('SET_HAZARD_ROUTES', response.data.hazardStats.routes)
      context.commit('SET_HAZARD_CATS', response.data.hazardStats.categories)
      context.commit('SET_HAZARD_CODES', response.data.hazardStats.hazardCodes)
      context.commit('SET_HAZARD_ORGANISMS', response.data.hazardStats.testOrganisms)
    })
    .catch((error) => {
      console.warn('SEARCH module is not available: %o', getErrorMessage(error))
      context.commit('removeFeature', { search: {} })
    })
}

export default {
  state,
  getters,
  mutations,
  actions,
}
